export const CONTROLS = {
  ORBIT: 'orbit',
  DEVICE: 'device',
};
